/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IndustryEnum } from './IndustryEnum';
import { IndustryEnumFromJSON, IndustryEnumFromJSONTyped, IndustryEnumToJSON } from './IndustryEnum';

/**
 *
 * @export
 * @interface PatchedSettingserializer
 */
export interface PatchedSettingserializer {
  /**
   *
   * @type {number}
   * @memberof PatchedSettingserializer
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedSettingserializer
   */
  performance?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSettingserializer
   */
  robustness?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSettingserializer
   */
  fairness?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSettingserializer
   */
  explainability?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSettingserializer
   */
  overall?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSettingserializer
   */
  riskReward?: string;
  /**
   *
   * @type {IndustryEnum}
   * @memberof PatchedSettingserializer
   */
  industry?: IndustryEnum;
  /**
   *
   * @type {number}
   * @memberof PatchedSettingserializer
   */
  key?: number;
}

/**
 * Check if a given object implements the PatchedSettingserializer interface.
 */
export function instanceOfPatchedSettingserializer(value: object): value is PatchedSettingserializer {
  return true;
}

export function PatchedSettingserializerFromJSON(json: any): PatchedSettingserializer {
  return PatchedSettingserializerFromJSONTyped(json, false);
}

export function PatchedSettingserializerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedSettingserializer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    performance: json['performance'] == null ? undefined : json['performance'],
    robustness: json['robustness'] == null ? undefined : json['robustness'],
    fairness: json['fairness'] == null ? undefined : json['fairness'],
    explainability: json['explainability'] == null ? undefined : json['explainability'],
    overall: json['overall'] == null ? undefined : json['overall'],
    riskReward: json['risk_reward'] == null ? undefined : json['risk_reward'],
    industry: json['industry'] == null ? undefined : IndustryEnumFromJSON(json['industry']),
    key: json['key'] == null ? undefined : json['key'],
  };
}

export function PatchedSettingserializerToJSON(value?: Omit<PatchedSettingserializer, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    performance: value['performance'],
    robustness: value['robustness'],
    fairness: value['fairness'],
    explainability: value['explainability'],
    overall: value['overall'],
    risk_reward: value['riskReward'],
    industry: IndustryEnumToJSON(value['industry']),
    key: value['key'],
  };
}
